// extracted by mini-css-extract-plugin
module.exports = {"content":"about-module--content--20lL2","description":"about-module--description--3MkqR"};